module.exports = __webpack_public_path__ + "img/symbol_3.c6f9ccf7.png";